var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"heading-5"},[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }